import { jsx } from "react/jsx-runtime";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import { validateTidalLicense } from "../../base/index.js";
function FormatColorText(props) {
  return /* @__PURE__ */ jsx(
    FormatColorTextIcon,
    {
      "data-testid": "FormatColorText",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FormatColorText",
      "data-tidal-icon-meta": "editing,attachment"
    }
  );
}
FormatColorText.tidalIconMeta = {
  categories: "editing,attachment",
  name: "FormatColorText"
};
validateTidalLicense();
export {
  FormatColorText
};
//# sourceMappingURL=FormatColorText.js.map
